import { cssThemedValue, typographyCss } from '@creditornot/cb-ingredients';
import { Tabs } from '@creditornot/cb-tabs';
import styled, { css } from 'styled-components';

import { MENU_MOBILE_BREAKPOINT } from '../constants';

const PANEL_HEADER_HEIGHT = 64;
const SIDE_PANEL_MAX_WIDTH = 620;
const SIDE_PANEL_MOBILE_MAX_WIDTH = 320;

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  width: ${SIDE_PANEL_MAX_WIDTH}px;

  @media (max-width: ${SIDE_PANEL_MAX_WIDTH}px) {
    max-width: ${MENU_MOBILE_BREAKPOINT}px;
  }

  @media (max-width: ${MENU_MOBILE_BREAKPOINT}px) {
    max-width: max(100%, ${SIDE_PANEL_MOBILE_MAX_WIDTH}px);
  }
`;

export const TabsContainer = styled.div`
  position: sticky;
  display: flex;
  flex-direction: column;
  z-index: 1;
  top: ${PANEL_HEADER_HEIGHT}px;
  background: ${cssThemedValue('surfaceMain')};
`;

export const StyledTabs = styled(Tabs)`
  width: 100%;
  overflow-x: scroll;
  border-block-end: 1px solid ${cssThemedValue('borderPrimary')};
`;

export const SectionTitle = styled.div`
  ${typographyCss.Title1};
  padding: 24px 0;
  border-block-end: 1px solid ${cssThemedValue('borderPrimary')};
`;

export const SectionInfo = styled.div`
  margin-block-start: 8px;
  ${typographyCss.Small};
  font-weight: normal;
  white-space: normal;
`;

type SectionProps = {
  $isShown: boolean;
};

export const TabbedSection = styled.section<SectionProps>`
  ${({ $isShown }) => css`
    display: ${$isShown ? 'block' : 'none'};
  `}
`;
